<!-- app.component.html -->
<div class="container-fluid">
  <router-outlet></router-outlet>
</div>

<div class="loading-buttons" id="loader" style="display: none;">
    <div class="loading-icon">
      <img class="placeholder-img" src="/assets/img/loader/ajax-loader.gif" />
    </div>
  </div>
